<template>
  <el-dialog title="Extract Vote UNIT" :visible.sync="isOpen" width="7.2rem" append-to-body :close-on-click-modal="false"
    destroy-on-close>
    <div>
      <div class="spaceLeft" style="margin-bottom:0.42rem">
        <div class="detail-title-2">Proposal No. {{ pageData.proposal && pageData.proposal.id }}</div>
        <voteStatusComp v-if="pageData.proposal && pageData.proposal.status" :status.sync="pageData.proposal.status" :over.sync="pageData.over" :cumulative.sync="pageData.vote"
          :threshold.sync="threshold" />
      </div>
      <div>
        <!-- <div class="detail-item spaceLeft">
          <span class="detail-item-label">Duration:</span>
          <span
            >{{ moment(pageData.timestamp).format("YYYY-MM-DD HH:mm:ss") }} ~
            {{
              moment(pageData.over * 1000).format("YYYY-MM-DD HH:mm:ss")
            }}</span
          >
        </div> -->
        <div class="detail-item spaceLeft">
          <span class="detail-item-label">Total votes:</span>
          <span v-if="pageData.proposal && pageData.proposal.totalWeight">
            <big-number :number="pageData.proposal.totalWeight" />
          </span>
          <span class="unit">UNIT</span>
        </div>
        <div class="detail-item spaceLeft">
          <span class="detail-item-label">My vote :</span>
          <big-number :number="pageData.weight" />
          <span class="unit">UNIT</span>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">Cancel</el-button>
      <loading-btn class="common-btn-blue-sm" label="Extract" @clickHandle="save" />
    </span>
  </el-dialog>
</template>

<script>
import { deepClone } from "@/utils/index.js";
import voteStatusComp from "@/views/governance/components/voteStatusComp.vue";
export default {
  data() {
    return {
      isOpen: false,
      pageData: {},
      statusMap: this.$store.getters.auctionStatusMap,
      threshold: 0
    };
  },
  components: { voteStatusComp },
  methods: {
    open({ row, threshold } = {}) {
      this.isOpen = true;
      this.pageData = deepClone(row);
      this.init();
    },
    close() {
      this.isOpen = false;
      this.pageData = {};
    },
    init() {
      this.contractDao = this.$store.getters.contractMap["contractDao"].contract;
      this.contractDaoAddress = this.$store.getters.contractMap["contractDao"].address;
      this.getThreshold()

    },
    async getThreshold() {
      try {
        this.threshold = await this.contractDao.methods.quorum(this.pageData.proposal.endBlock).call({ from: this.$store.getters.metaMaskObj.account })
      } catch (e) {
        console.log(e);
      }
    },
    save(btn) {
      const tx_builder = this.contractDao.methods["withdraw"](
        this.pageData.proposalId
      );
      const encoded_tx = tx_builder.encodeABI();
      web3.eth
        .sendTransaction({
          gas: this.$store.getters.gas,
          from: this.$store.getters.metaMaskObj.account,
          to: this.contractDaoAddress,
          value: 0,
          data: encoded_tx
        })
        .then(res => {
          setTimeout(() => {
            this.$emit("success");
            btn.closeLoad();
            this.close();
          }, 3000)
          this.$message.success("operation successful!");
        })
        .catch(error => {
          if(error.code === 4001){
            this.$message.error("You have rejected this transaction");
          }else{
            this.$message.error("operation failed");
          }
          console.error(error);
          btn.closeLoad();
        });
    }
  },
  created() { }
};
</script>
<style scoped lang="scss">
.unit {
  font-size: 0.18rem;
  font-weight: 400;
  color: #929dad;
  margin-left: 0.04rem;
}

.big-num {
  font-size: 0.28rem;
  font-family: Roboto-Medium, Roboto;
  font-weight: 500;
  color: #1f1f1f;
}

.detail-item {
  margin-bottom: 0.32rem;
}
</style>
